import styled from "styled-components";

const StyledTableTitle = styled.p`
    font-weight: 600px;
    margin: 40px 0 0 0;
`;

const StyledButtonContainer = styled.div`
    display: flex;
    justify-content: space-between;
`;

const StyledButtonList = styled.button`
    text-decoration: underline;
    color: #0d6efd;
    background-color: none;
    background: none;
    border: none;

    &:hover {
        color: #0a58ca;
    }
`;

const StyledDeleteButton = styled.button`
    text-decoration: underline;
    color: #0d6efd;
    background-color: none;
    background: none;
    border: none;

    &:hover {
        color: #0a58ca;
    }
`;

export default {
    StyledTableTitle,
    StyledButtonContainer,
    StyledButtonList,
    StyledDeleteButton,
};
